import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LEARNING_ASSET_TYPE_OBJECT, ASSET_TYPE_ICONS } from '../Constants';

export default class VerbAssetIcon extends PureComponent {
    static propTypes = {
        learningAssetType: PropTypes.string,
        isGreyScale: PropTypes.bool,
        className: PropTypes.string
    };

    render() {
        const { learningAssetType, isGreyScale = false, className = '' } = this.props;
        const assetType = learningAssetType.toUpperCase() || 'ACTIVITY';
        const assetTypeIcon = ASSET_TYPE_ICONS[assetType];
        const tooltip = (
            <Tooltip id={'tooltip'}>
                {LEARNING_ASSET_TYPE_OBJECT[assetType].label_hover || LEARNING_ASSET_TYPE_OBJECT[assetType].label}
            </Tooltip>
        );

        return (
            <span className={cns('asset-type-icon', className)}>
                <OverlayTrigger placement={'top'} transition={false} overlay={tooltip}>
                    <i className={cns('fal fa-fw', assetTypeIcon, { [assetType]: !isGreyScale })} />
                </OverlayTrigger>
            </span>
        );
    }
}
